export function normalizeSkillName(name: string): string {
  return (name || '').trim().toLowerCase();
}

// Flattens vacancy hardSkills ([{ skills: [{ name }] }]) into a set of normalized names.
export function buildSkillNameSet(hardSkills: { skills?: { name?: string }[] }[]): Set<string> {
  const names = new Set<string>();
  (hardSkills || []).forEach(branch =>
    (branch?.skills || []).forEach(skill => {
      const name = normalizeSkillName(skill?.name);
      if (name) {
        names.add(name);
      }
    })
  );
  return names;
}

export function isSkillMatched(skillNames: Set<string> | null, name: string): boolean {
  return !!skillNames && skillNames.has(normalizeSkillName(name));
}
